export const USER_TYPE = 'user';
export const SHARE_TYPE = 'share';


export const SCREEN_LAYOUT_TYPE = [
    { id: USER_TYPE, label: USER_TYPE },
    { id: SHARE_TYPE, label: SHARE_TYPE },
];